import DPBoundingBox from '../modules/DPBoundingBox';


const calculateSpaceAroundFeature = (tooltipBB, maxScreenBB, isLeftOrRight) => {
	// Calculate features
	let spaceAroundRatio = {
		width: tooltipBB.width / maxScreenBB.width,
		height: tooltipBB.height / maxScreenBB.height
	};
	return isLeftOrRight ? spaceAroundRatio.width - spaceAroundRatio.height : spaceAroundRatio.height - spaceAroundRatio.width;
};

const determineGoldenIncrement = (spaceAroundFeature, isOverHeight, isLeftOrRight, maxDocBB, tooltipBB, closerToTargetBB, tooltipPos) => {
	let moveCloserToWinBorder = Math.sign(spaceAroundFeature) < 0;
	if (isOverHeight) moveCloserToWinBorder = isLeftOrRight;
	let range = 0;
	switch (tooltipPos.base) {
		case 'left': range = moveCloserToWinBorder ? [maxDocBB.left, tooltipBB.left] : [tooltipBB.left, closerToTargetBB.left]; break;
		case 'right': range = moveCloserToWinBorder ? [tooltipBB.right, maxDocBB.right] : [closerToTargetBB.right, tooltipBB.right]; break;
		case 'top': range = moveCloserToWinBorder ? [maxDocBB.top, tooltipBB.top] : [tooltipBB.top, closerToTargetBB.top]; break;
		case 'bottom': range = moveCloserToWinBorder ? [tooltipBB.bottom, maxDocBB.bottom] : [closerToTargetBB.bottom, tooltipBB.bottom]; break;
	}
	return (moveCloserToWinBorder ? -1 : 1) * (range[1] - range[0]) / 2;
};

const modifyTooltipPosition = (increment, tooltipLayer, tooltipBB, tooltipPos, isLeftOrRight) => {
	if (isLeftOrRight) {
		const tooltipBBBkp = { ...tooltipBB };
		tooltipLayer.style.width = (tooltipBB.width - increment) + 'px';

		if (tooltipPos.base === 'left') {
			const newWidth = $(tooltipLayer).outerWidth(false);
			if (newWidth !== tooltipBBBkp.width) {
				$(tooltipLayer).offset({ left: tooltipBB.left - (newWidth - tooltipBBBkp.width) });
			}
		}
		if (tooltipPos.align === 'bottom') {
			const newHeight = $(tooltipLayer).outerHeight(false);
			if (newHeight !== tooltipBBBkp.height) {
				$(tooltipLayer).offset({ top: tooltipBB.bottom - newHeight + 1 });
			}
		}
	}
	else {
		// adjusting height doesn't automatically change a width ... so changing width instead
		const tooltipHeightBkp = tooltipBB.height;
		tooltipLayer.style.width = (tooltipBB.width + increment) + 'px';


		if (tooltipPos.base === 'top') {
			const newHeight = $(tooltipLayer).outerHeight(false);
			if (newHeight !== tooltipHeightBkp) {
				$(tooltipLayer).offset({ top: tooltipBB.top - (newHeight - tooltipHeightBkp) });
			}
		}
		if (tooltipPos.align === 'right') {
			$(tooltipLayer).offset({ left: tooltipBB.left - increment });
		}
	}
};


export default (targetBB, initTooltipBB, tooltipLayer, tooltipPos, maxScreenBB, maxDocBB, isFixedPos, dpDebugEn, maxIterations = 10) => {

	let iterations = 0;
	let tooltipBB = { ...initTooltipBB };
	let lastTooltipBB = { ...initTooltipBB };
	let featureSpaceAround = 1;
	let isOverHeight = false;
	let lastIsOverHeight = false;

	const isLeftOrRight = ['left', 'right'].includes(tooltipPos.base);

	while (iterations < maxIterations) {

		const prevFeatureSpaceAround = featureSpaceAround;

		// Calculate the space around feature
		featureSpaceAround = calculateSpaceAroundFeature(tooltipBB, maxScreenBB, isLeftOrRight);

		// Check not a beneficial golden iteration direction
		if (iterations > 0 && !isOverHeight && Math.abs(featureSpaceAround) > Math.abs(prevFeatureSpaceAround)) {
			// reverse to last position (algorithm failed)
			if (dpDebugEn) console.log('Golden ratio: (bad direction)');
			tooltipLayer.style.width = (lastTooltipBB.width) + 'px';
			$(tooltipLayer).offset({
				left: lastTooltipBB.left + (isFixedPos ? $(window).scrollLeft() : 0),
				top: lastTooltipBB.top + (isFixedPos ? $(window).scrollTop() : 0)
			});


			iterations--;
			tooltipBB = { ...lastTooltipBB };
			isOverHeight = lastIsOverHeight;
			break;
		}

		lastTooltipBB = { ...tooltipBB };

		// Check over height
		lastIsOverHeight = isOverHeight;
		isOverHeight = tooltipBB.height > maxScreenBB.height;

		// Was algorithm successful so finish ?
		let isBestPosFound = false;
		if (!isOverHeight) {
			if (iterations === 0) {
				isBestPosFound = Math.abs(featureSpaceAround) <= 0.03;
			} else {
				const featureSpaceAroundDerivation = Math.abs(prevFeatureSpaceAround) - Math.abs(featureSpaceAround);
				isBestPosFound = Math.abs(featureSpaceAround) <= 0.1 || featureSpaceAroundDerivation <= 0.05;
			}
		}
		if (isBestPosFound) break;

		// Determine size/position increment by golden ratio
		const increment = determineGoldenIncrement(
			featureSpaceAround,
			isOverHeight,
			isLeftOrRight,
			maxDocBB,
			tooltipBB,
			iterations === 0 ? targetBB : lastTooltipBB,
			tooltipPos
		);

		// Change to new size/position
		modifyTooltipPosition(increment, tooltipLayer, tooltipBB, tooltipPos, isLeftOrRight);


		tooltipBB = DPBoundingBox.getElBoundingBox(tooltipLayer, false, isFixedPos);

		if (DPBoundingBox.isEqual(lastTooltipBB, tooltipBB)) {
			if (dpDebugEn) console.log('Golden ratio: ENDED (size modification had no effect)', iterations);
			break;
		}


		iterations++;
	}
	if (dpDebugEn) console.log(`Golden ratio: SUCCESS (by ${iterations} iterations)`);
	return {
		wasPosAdjusted: iterations > 0,
		tooltipBB: tooltipBB,
		isOverHeight: isOverHeight
	};
};